// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bhh_sq","PhotoTitleEditForm__cancelBtn":"iy_b bhh_su bhh_st"};